export default __webpack_public_path__ + "static/media/mobile-photo-3.bc094ea5.jpg";